import { t as StyledSvgIcon } from "./SvgIcon.styles-A_BRPYMJ.js";
import * as React$1 from "react";
import { jsx } from "react/jsx-runtime";

//#region src/assets/icons/custom/Month.svg?react
const SvgMonth = (props) => /* @__PURE__ */ React$1.createElement("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React$1.createElement("path", {
	d: "M5.5 19H3.5L3.5 5L5.5 5L5.5 19ZM19.5 19V5L3.5 5L3.51074 4.7959C3.6062 3.85435 4.35435 3.1062 5.2959 3.01074L5.5 3L19.5 3C20.6046 3 21.5 3.89543 21.5 5V19C21.5 20.1046 20.6046 21 19.5 21H5.5C4.46435 21 3.613 20.2128 3.51074 19.2041L3.5 19H19.5Z",
	fill: "currentColor"
}), /* @__PURE__ */ React$1.createElement("path", {
	d: "M20.502 7V9H4.50195V7H20.502Z",
	fill: "currentColor"
}), /* @__PURE__ */ React$1.createElement("path", {
	d: "M7.50195 11H9.50195V13H7.50195V11Z",
	fill: "currentColor"
}), /* @__PURE__ */ React$1.createElement("path", {
	d: "M11.502 11H13.502V13H11.502V11Z",
	fill: "currentColor"
}), /* @__PURE__ */ React$1.createElement("path", {
	d: "M15.502 11H17.502V13H15.502V11Z",
	fill: "currentColor"
}), /* @__PURE__ */ React$1.createElement("path", {
	d: "M7.50195 15H9.50195V17H7.50195V15Z",
	fill: "currentColor"
}), /* @__PURE__ */ React$1.createElement("path", {
	d: "M11.502 15H13.502V17H11.502V15Z",
	fill: "currentColor"
}), /* @__PURE__ */ React$1.createElement("path", {
	d: "M15.502 15H17.502V17H15.502V15Z",
	fill: "currentColor"
}));

//#endregion
//#region src/icons/MonthIcon.tsx
function MonthIcon(props) {
	return /* @__PURE__ */ jsx(StyledSvgIcon, {
		component: SvgMonth,
		inheritViewBox: true,
		...props
	});
}

//#endregion
export { MonthIcon as t };
//# sourceMappingURL=MonthIcon-BVreKn0-.js.map